import * as React from "react";
import { compareValues } from "../utils/sortingUtils";
import "../../assets/scss/components/generic/sort.scss";

export interface SortProps {
	sortList: Array<Array<any>>; //array of type any
	sortKey: string; // key to sort
	colName: string;
	sortedColName: string | null;
	onSort: (data: Array<Array<any>>, sortState: eSortState, sortKey: string) => void;
}

export interface SortState {
	sortState: eSortState;
}

export enum eSortState {
	// NORMAL,
	ASC,
	DESC
}

export function sort(
	initialData: Array<Array<any>>,
	sortState: eSortState,
	sortKey: string,
	onSort: (data: Array<Array<any>>, sortState: eSortState, sortKey: string) => void
) {
	if (sortState === eSortState.ASC || sortState === eSortState.DESC) {
		// sort in ascending or descending
		let sortData = initialData.map(group => {
			const groupTemp = [...group];
			if (sortState === eSortState.DESC) {
				return groupTemp.sort(compareValues(sortKey, "desc"));
			} else {
				return groupTemp.sort(compareValues(sortKey));
			}
		});
		onSort(sortData, sortState, sortKey);
	}
}

class Sort extends React.Component<SortProps, SortState> {
	state = {
		sortState: eSortState.ASC
	};

	onSortClick = () => {
		// set the state to next state
		// and then call sort function
		this.setState({ sortState: (this.state.sortState + 1) % 2 }, () =>
			sort(this.props.sortList, this.state.sortState, this.props.sortKey, this.props.onSort)
		);
	};

	render() {
		return (
			<div className="col_srt_cont">
				<button onClick={this.onSortClick}>
					<div className="col_sorting">
						<label className="col_nm">{this.props.colName}</label>
						<div className="sort_icons">
							<i className="edel-icon-sort-1"></i>
							<i className="edel-icon-sort-2"></i>
						</div>
					</div>
				</button>
			</div>
		);
	}
}
export default Sort;
